import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import Footer from "./Footer";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import Header from "./Header";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState(0);
  const [activeTab, setActiveTab] = useState("description");

  if (!product) {
    return (
      <div className="product-detail">
        <Header />
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, quantity);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="product-detail">
      <Header />

      <main className="product-detail__main">
        {/* 面包屑导航 */}
        <div className="breadcrumb">
          <div className="breadcrumb__container">
            <Link to="/" onClick={toTop}>
              HOME
            </Link>
            <span className="breadcrumb__separator">»</span>
            <Link to="/shop" onClick={toTop}>
              SHOP
            </Link>
          </div>
        </div>

        <div className="product-detail__container">
          <div className="product-detail__content">
            {/* 左侧产品图片 */}
            <div className="product-detail__images">
              <div className="product-images">
                <div className="product-images__main">
                  <img
                    src={product.images[selectedImage]}
                    alt={product.name}
                    className="product-images__main-img"
                  />
                </div>

                {/* 缩略图 */}
                {product.images && product.images.length > 1 && (
                  <div className="product-images__thumbnails">
                    {product.images.map((image, index) => (
                      <button
                        key={index}
                        className={`product-images__thumb ${
                          selectedImage === index ? "active" : ""
                        }`}
                        onClick={() => setSelectedImage(index)}
                      >
                        <img src={image} alt={`${product.name} ${index + 1}`} />
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* 右侧产品信息 */}
            <div className="product-detail__info">
              <h1 className="product-detail__title">{product.name}</h1>

              <div className="product-detail__price">${product.price}</div>

              <div className="product-detail__meta">
                <p className="product-detail__sku">
                  {product.isbn
                    ? product.isbn.replace(/-/g, "")
                    : `${product.category}${product.id
                        .toString()
                        .padStart(4, "0")}`}{" "}
                  |{" "}
                  {product.isbn ||
                    `${product.category}${product.id
                      .toString()
                      .padStart(4, "0")}`}{" "}
                  | {product.name}
                </p>

                <div className="product-detail__stock">
                  <span className="stock-status in-stock">In stock</span>
                </div>
              </div>

              {/* 数量选择和添加到购物车 */}
              <div className="product-detail__actions">
                <div className="quantity-selector">
                  <button
                    className="quantity-btn quantity-btn--minus"
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                  >
                    -
                  </button>
                  <input
                    type="number"
                    value={quantity}
                    onChange={(e) =>
                      setQuantity(Math.max(1, parseInt(e.target.value) || 1))
                    }
                    className="quantity-input"
                    min="1"
                  />
                  <button
                    className="quantity-btn quantity-btn--plus"
                    onClick={() => setQuantity(quantity + 1)}
                  >
                    +
                  </button>
                </div>

                <button className="add-to-cart-btn" onClick={handleAddToCart}>
                  ADD TO CART
                </button>
              </div>

              {/* 产品详细信息 */}
              <div className="product-detail__additional">
                <p className="product-detail__sku-line">
                  <strong>SKU:</strong>{" "}
                  {product.isbn
                    ? product.isbn.replace(/-/g, "")
                    : `${product.category}${product.id
                        .toString()
                        .padStart(4, "0")}`}
                </p>

                <p className="product-detail__category">
                  <strong>Category:</strong>
                  <Link to="/shop" onClick={toTop}>
                    {product.category}
                  </Link>
                </p>
              </div>

              {/* 社交分享按钮 */}
              <div className="product-detail__social">
                <button
                  className="social-btn social-btn--facebook"
                  title="Share on Facebook"
                >
                  <i className="fab fa-facebook-f"></i>
                </button>
                <button
                  className="social-btn social-btn--twitter"
                  title="Share on Twitter"
                >
                  <i className="fab fa-twitter"></i>
                </button>
                <button
                  className="social-btn social-btn--email"
                  title="Share via Email"
                >
                  <i className="fas fa-envelope"></i>
                </button>
                <button
                  className="social-btn social-btn--pinterest"
                  title="Share on Pinterest"
                >
                  <i className="fab fa-pinterest"></i>
                </button>
                <button
                  className="social-btn social-btn--linkedin"
                  title="Share on LinkedIn"
                >
                  <i className="fab fa-linkedin"></i>
                </button>
              </div>
            </div>
          </div>

          {/* 产品描述标签页 */}
          <div className="product-detail__tabs">
            <div className="tabs">
              <div className="tabs__nav">
                <button
                  className={`tabs__btn ${
                    activeTab === "description" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("description")}
                >
                  DESCRIPTION
                </button>
                {product.Features && (
                  <button
                    className={`tabs__btn ${
                      activeTab === "features" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("features")}
                  >
                    FEATURES
                  </button>
                )}
                {product.pages && (
                  <button
                    className={`tabs__btn ${
                      activeTab === "details" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("details")}
                  >
                    DETAILS
                  </button>
                )}
              </div>

              <div className="tabs__content">
                {activeTab === "description" && (
                  <div className="tab-content tab-content--description">
                    {product.description && product.description.length > 0 ? (
                      <div className="description-content">
                        {product.description.map((desc, index) => (
                          <p key={index} className="description-text">
                            {desc}
                          </p>
                        ))}
                      </div>
                    ) : (
                      <p>No description available.</p>
                    )}
                  </div>
                )}

                {activeTab === "features" && product.Features && (
                  <div className="tab-content tab-content--features">
                    <ul className="features-list">
                      {product.Features.map((feature, index) => (
                        <li key={index} className="features-item">
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {activeTab === "details" && (
                  <div className="tab-content tab-content--details">
                    <div className="details-grid">
                      {product.publisher && (
                        <div className="detail-item">
                          <strong>Publisher:</strong> {product.publisher}
                        </div>
                      )}
                      {product.isbn && (
                        <div className="detail-item">
                          <strong>ISBN:</strong> {product.isbn}
                        </div>
                      )}
                      {product.pages && (
                        <div className="detail-item">
                          <strong>Pages:</strong> {product.pages}
                        </div>
                      )}
                      {product.country && (
                        <div className="detail-item">
                          <strong>Country:</strong> {product.country}
                        </div>
                      )}
                      {product.rating && (
                        <div className="detail-item">
                          <strong>Rating:</strong> {product.rating}/5.0
                        </div>
                      )}
                      {product.reviews && (
                        <div className="detail-item">
                          <strong>Reviews:</strong> {product.reviews}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ProductDetail;
